import React from "react";

import "../App.css";
import { Link } from "react-router-dom";

export default function YpoCarbonBanner() {
  return (
    <section className="container my-5">
      <div
        className="text-center text-white p-5 rounded"
        style={{
          background: "linear-gradient(90deg, #0b3b5e, #1565c0)",
        }}
      >
        {/* Heading */}
        <h2
          className="fw-bold mb-3"
          style={{
            fontWeight: "bold",
            fontFamily: "Oswald, sans-serif",
          }}
        >
          YPO GIS SUMMIT AMAZON FLIGHT CARBON CALCULATOR
        </h2>

        {/* Description */}
        <p
          className="mb-3"
          style={{
            maxWidth: "700px",
            margin: "0 auto",
          }}
        >
          As part of our commitment to sustainability and responsible
          leadership, YPO / YNG is proud to introduce the Flight Carbon
          Calculator for the upcoming Global Impact Summit (GIS) in Brazil.
        </p>
        <p
          className="mb-4"
          style={{
            maxWidth: "700px",
            margin: "0 auto",
          }}
        >
          This tool allows all summit attendees to measure the carbon footprint
          of their flights to and from Brazil and offset it through verified,
          high-impact carbon projects.
        </p>

        <Link
          to="/calculator"
          className="btn btn-light px-4"
          style={{ fontFamily: "Oswald, sans-serif", color: "#063970" }}
        >
          Carbon Calculator
        </Link>
      </div>
    </section>
  );
}
